import { mapState, mapMutations } from 'vuex'

export default {
  computed: mapState(['api', 'user']),
  methods: {
    ...mapMutations(['addNotification']),

    async request (method, uri, data, headers) {
      if (!this.user.accesToken) return

      const additionalHeaders = headers || {}
      const options = {
        method: method,
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: `Bearer ${this.user.accesToken}`,
          ...additionalHeaders
        }
      }

      if (method !== 'GET' && data) options.body = JSON.stringify(data)

      const request = await fetch(`${this.api.host}${uri}`, options)
      const response = await request.json()
      const notification = { type: 'danger', message: null }
      if (!request.ok && request.status === 401) {
        notification.message = 'Authorization Error'
        this.addNotification({ notification })
        this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/')
          })
      }
      if (request.status >= 500) {
        notification.message = 'Internal server error, please try again later'
        this.addNotification({ notification })
      }
      if (request.status === 404) {
        if (response.message) {
          notification.message = response.message
          this.addNotification({ notification })
        } else {
          notification.message = 'Server unavailable, please try again later'
          this.addNotification({ notification })
        }
      }
      return {
        info: request,
        body: response
      }
    }
  }
}
